import { render, staticRenderFns } from "./partnerBankSummary.vue?vue&type=template&id=8cede77c&scoped=true"
import script from "./partnerBankSummary.vue?vue&type=script&lang=js"
export * from "./partnerBankSummary.vue?vue&type=script&lang=js"
import style0 from "./partnerBankSummary.vue?vue&type=style&index=0&id=8cede77c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cede77c",
  null
  
)

export default component.exports